export const LogEventLevel = {
    Verbose: "Verbose",
    Debug: "Debug",
    Information: "Information",
    Warning: "Warning",
    Error: "Error",
    Fatal: "Fatal"
} as const;

export type LogEventLevel = typeof LogEventLevel[keyof typeof LogEventLevel];
